module.exports = __webpack_public_path__ + "static/pillow-4-f6c2f8f63008cbf5fd8d9540c80170f9.png";